document.addEventListener("DOMContentLoaded", function () {
  var menu_mob = document.querySelectorAll("#menu-mobile");
  var overlay = document.querySelector(".overlay-bg");
  var close_menu_mob = document.querySelectorAll("#close-menu-mobile");
  var toggle_btn = document.querySelectorAll(".toggle-mob");
  var toggle_search = document.querySelectorAll("#toggle-search");
  var search_form = document.querySelectorAll("#search-form");
  var isSearchActive = false;

  toggle_btn.forEach((el) =>
    el.addEventListener("click", function () {
      handleMenuToggle(menu_mob, overlay, true);
    })
  );

  toggle_search.forEach((el) => {
    el.addEventListener("click", function () {
      isSearchActive = !isSearchActive;
      handleSearch(search_form, isSearchActive);
    });
  });

  close_menu_mob.forEach((el) =>
    el.addEventListener("click", function () {
      handleMenuToggle(menu_mob, overlay, false);
    })
  );
  overlay.addEventListener("click", function (e) {
    handleMenuToggle(menu_mob, overlay, false);
  });
  initializeSwiperHeader();
  
});

function initializeSwiperHeader() {
  new Swiper(".swiper-top-bar", {
    loop: true,
    speed: 7000,
    autoplay: {
      delay: 12,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    watchSlidesProgress: true,
  });
}

function handleMenuToggle(menu, overlay, active) {
  if (active) {
    menu.forEach((el) => el.classList.add("active"));
    overlay.classList.add("active");
  } else {
    menu.forEach((el) => el.classList.remove("active"));
    overlay.classList.remove("active");
  }
}

function handleSearch(menu, active) {
  if (active) {
    menu.forEach((el) => el.classList.add("!block"));
  } else {
    menu.forEach((el) => el.classList.remove("!block"));
  }
}

async function getSearchResultItems(query) {
  if (query == "" || query == null) {
    console.log("null");
    closeSearchResult();
  } else {
    try {
      const response = await fetch(
        window.Shopify.routes.root +
          `search/suggest.json?q=${query}&resources[limit]=5&resources[type]=product&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.sku`
      );

      const data = await response.json();

      const searchResultWrapper = document.querySelectorAll(
        ".wrapper-search-result"
      );

      document
        .querySelectorAll(".wrapper-search-result li")
        .forEach((li) => li.remove());

      data?.resources?.results?.products.forEach(
        ({ title, url, image, tags }) => {
          if (checkIfIsGift(title, tags)) return;
          searchResultWrapper.forEach((el) => {
            const listItem = document.createElement("li");

            listItem.innerHTML = `
      <a href="${url}" title="${title}" class="flex items-center gap-3">
        <div class="result-search-image" style="width:80px;height:80px; min-width:80px">
          <img class="object-contain w-full" src="${image}" alt="${title}"/>
        </div>
        <div class="result-search-right">
          <h3>${title}</h3>
        </div>
      </a>
    `;

            el.appendChild(listItem);
          });
        }
      );

      document
        .querySelectorAll(".search-result")
        .forEach((el) => el.classList.add("active"));
    } catch (error) {
      console.error(error);
    }
  }
}

function checkIfIsGift(title, tags) {
  return (
    title.toLowerCase().includes("brinde") ||
    title.toLowerCase().includes("potes") ||
    tags.includes("not-show")
  );
}

function closeSearchResult() {
  document
    .querySelectorAll(".search-result")
    .forEach((el) => el.classList.remove("active"));
}
